export default "__VITE_ASSET__CvYjB1in__"